import React from 'react';
import { Link } from 'react-router-dom';

import './button-cta.scss';

export default ({
  handleClick,
  label,
  path,
  bordered,
  href,
  customStyle = ''
}) => {
  const style = bordered
    ? `button-cta button-cta--bordered ${customStyle}`
    : `button-cta ${customStyle}`
  if (path) {
    return (
      <Link
        className={style}
        to={path}
        onClick={e => {
          handleClick()
        }}
      >
        {label}
      </Link>
    )
  }
  if (href) {
		const el = document.createElement("div");
		el.innerHTML = href;
		href = el.innerText;
		return (
      <a className={style} href={href}>
        {label}
      </a>
    )
  }
  return (
    <a className={style} onClick={handleClick}>
      {label}
    </a>
  )
};



// WEBPACK FOOTER //
// ./src/components/atoms/ButtonCTA/index.js